import { styled } from '@mui/material';

export const List = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
});
